<template>
  <section class="color-light-black">
    <BaseAccordion
      v-for="(requisite,index) in value"
      :key="index"
      class="mb-4 rounded-md border"
    >
      <template #trigger="{ setIsOpen, isOpen }">
        <button
          :id="`${index}-header`"
          :aria-expanded="isOpen ? 'true' : 'false'"
          :aria-controls="`${index}-advanced-panel`"
          class="
            accordion-button
            flex
            items-center
            justify-between
            w-full
            focus:outline-none
            color-deep-black
            p-4
            md:p-6
            font-semibold
            text-lg
            md:text-xl
            leading-5
            md:leading-6
            text-left
            "
          @click="setIsOpen(!isOpen)"
          @keyup.space="setIsOpen(!isOpen)"
        >
          <div class="pr-2">{{ requisite.name || 'Untitled Requisite' }}</div>
          <BaseIcon
            icon="chevron-down"
            class="toggle-icon"
            aria-hidden="true"
            :class="{ 'rotated': isOpen }"
          />
        </button>
      </template>
      <template #content>
        <section class="p-4 md:p-6 md:pt-5 border-t">
          <RequisiteAdvance
            :level="1"
            :value="requisite"
          />
        </section>
      </template>
    </BaseAccordion>
  </section>
</template>

<script>
import RequisiteAdvance from './RequisiteAdvance'

export default {
  components: {
    RequisiteAdvance,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.toggle-icon {
  color: #820000;
  border: 0.1rem solid #820000;
  width: 1.1rem;
  height: 1.1rem;
  padding: 2px;
  border-radius: 100%;
}
</style>
